export function compareVersions(leftVersion, rightVersion) {
    const leftParts = String(leftVersion || '').split('.')
        .map(part => Number(part) || 0);
    const rightParts = String(rightVersion || '').split('.')
        .map(part => Number(part) || 0);
    const maxLength = Math.max(leftParts.length, rightParts.length);

    for (let index = 0;index < maxLength;index += 1) {
        const leftValue = leftParts[index] || 0;
        const rightValue = rightParts[index] || 0;

        if (leftValue > rightValue) {
            return 1;
        }

        if (leftValue < rightValue) {
            return -1;
        }
    }

    return 0;
}
